import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { Router,NavigationEnd,ActivatedRoute } from '@angular/router';
declare  var jQuery:  any; 
import * as moment from 'moment'

@Component({
  selector: 'app-mybooking',
  templateUrl: './mybooking.component.html',
  styleUrls: ['./mybooking.component.scss']
})
export class MybookingComponent implements OnInit {

	is_authenticate_user: boolean = false;
	userticketList: any = "";

  constructor(
  	public authService: AuthService,	
  	private router: Router,
  ) { }

  ngOnInit() {

  	if(this.authService.isLoggedIn == true)
    {
      this.is_authenticate_user = true;
      //this.loginactivefunction();
    }else{
   this.router.navigate(['/singin']);
    }
  		this.authService.Userticketbooking().then((data) => {
	      this.userticketList = data;
	      console.log(this.userticketList);
	    });
      jQuery(document).ready(function(){
		      jQuery(".courses-name").click(function(){
		        if(jQuery(this).hasClass('active')){
		          // do nothing
		        }else{
		          var tabid = jQuery(this).attr('id');
		          jQuery(".courses-name").removeClass('active');
		          jQuery(this).addClass('active');
		          jQuery(".course-main-content").removeClass('active');
		          jQuery("#"+tabid+"-content").addClass("active");

		        }
		        return false;
		      });
		      jQuery(".mybooking-tab-btn a").click(function(){
				  jQuery(".mybooking-tab-cancellation").addClass("intro");
				  return false;
				});

		    });

  }

}
